module.exports = __webpack_public_path__ + "static/media/banner-1.2ae2dae6.webp";